var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadPhotoCaregiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 84",
    style: {
      enableBackground: "new 0 0 84 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FAD24D;}\r\n\t.st1{fill:#666666;}\r\n\t.st2{fill:#FED298;}\r\n\t.st3{fill:#F0BA7D;}\r\n\t.st4{fill:#21D0C3;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#FF5B62;}\r\n\t.st7{fill:#00BDB4;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42,
    cy: 42,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,53.7c-3.1-7.8-9.6-14.9-1.4-29.1c3.4-5.9,8.5-9.7,13.8-8.4c5.3-1.3,10.5,2.6,13.8,8.4 c8.2,14.2,1.7,21.3-1.4,29.1l-12.4,0L29.6,53.7L29.6,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.1,65.9c-0.4,0.6-1.2,5-2.1,8.8c6.5,4.6,14.5,7.3,23,7.3s16.5-2.7,23-7.3c-0.9-3.8-1.8-8.3-2.1-8.8 c-6-9.6-15.2-5.4-15.8-16.5c0,0-3,2.2-5.2,2.2c-2.3,0-5-2.1-5-2.1C36.3,60.6,27.1,56.3,21.1,65.9L21.1,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,51c-0.1-0.5-0.1-1-0.2-1.6c0,0-3,2.2-5.2,2.2c-2.3,0-5-2.1-5-2.1c0,0.6-0.1,1.1-0.2,1.6 c0.1,0,0.1,0.1,0.2,0.1l0,0c0.2,0.2,2.8,2.4,5,2.4c2.2,0,4.8-2.3,5-2.4l0,0C47,51.2,47.2,51.1,47.3,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.9,49.6c0.2,0.1,2.8,2.1,5,2.1c2.2,0,4.8-2,5-2.1c3.3-1.9,6-7.6,5.4-13.8c-0.5-5-6,2.3-9.7-8 c-5.4,11.3-10.5,4.6-11.1,8.9C30.9,41.3,33.5,47.3,36.9,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.6,57.5c-3.3,1.7-9.2,1.8-11.5,5.4c-0.4,0.6-1.2,7.2-2.2,11.8C25.4,79.3,33.4,82,42,82 c8.6,0,16.6-2.7,23.1-7.3c-1-4.6-1.9-11.1-2.2-11.8c-1.5-3.8-8.5-3.9-11.7-5.7C46.1,75.5,38.6,76.8,32.6,57.5L32.6,57.5L32.6,57.5 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.7,55.6c-0.2,5.7,0.8,13.8,7.2,15.9c-6,0.3-9.9-8.4-14.4-10.7L34.7,55.6L34.7,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.4,55.6c0.2,5.7-0.8,13.8-7.5,15.9c6.3,0.3,10.4-8.4,15.1-10.7L49.4,55.6L49.4,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.1,10.7h20.2c1.2,0,2.4,0.9,2.3,2.1l-0.8,9.2c-2.6-2.5-20.6-2.7-23.2,0l-0.8-9.2 C29.7,11.6,30.8,10.7,32.1,10.7z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 42.2,
    cy: 15.5,
    r: 3.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 64.5,
    cy: 64.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.6,
    y: 56.5,
    className: "st5",
    width: 1.7,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.6,
    y: 56.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 128.9998 1.585490e-04)",
    className: "st5",
    width: 1.7,
    height: 16
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhotoCaregiver);
export default __webpack_public_path__ + "static/media/Upload-Photo-caregiver.e08ce3fed3cd76e2e5865c005b392f4d.svg";
export { ForwardRef as ReactComponent };